import { add } from './add';

export function subtract(a: string | number, ...terms: (string | number | undefined)[]): number {
    return (Math.round(Number(a) * 100) - add(...terms) * 100) / 100;
}
